import React, { useImperativeHandle, useState } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../components/forms/InputField/InputField.component';
import FormDataPoint from '../../../components/forms/FormDataPoint/FormDataPoint.component';
import FormSectionHeader from '../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import ReceivingEquipmentInput from '../../../components/forms/lists/ReceivingEquipmentInput/ReceivingEquipmentInput.component';

// query
import { apolloClient } from '../../..';
import { GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM, GET_ALL_OUTSTANDING_PURCHASE_ORDERS_FOR_SELECT_FIELD } from '../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries';

// utils
import { createPurchaseOrderEquipmentList } from '../../inventory/InventoryDashboard/forms/ReceivingLog/ReceivingLog.form.controller.utils';

const PurchaseOrderDetailReceivingForm = React.forwardRef(({ prefillData = null, stage, errors }, ref) => {
    const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null)

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: prefillData ? { date: moment(), time: moment(), fromPurchaseOrder: prefillData['id'], equipment: [...createPurchaseOrderEquipmentList(prefillData['orderItems'])] } : {
            fromPurchaseOrder: '',
            date: moment(),
            time: moment(),
            equipment: [],
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormDataPoint label='Purchase Order' value={selectedPurchaseOrder ? `#${selectedPurchaseOrder.number} - ${selectedPurchaseOrder.vendorName}` : null} />

            <InputField 
                id="date"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('date', value)}
                value={formik.values.date}
                isValid={errors['date']}
            />

            <InputField 
                id="time"
                placeholder="Time"
                type="time"
                onChange={value => formik.setFieldValue('time', value)}
                value={formik.values.time}
                isValid={errors['time']}
            />

            <FieldArray 
                name='equipment'
                render={() => (
                    <div>
                        <FormSectionHeader text='Equipment' />

                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ReceivingEquipmentInput 
                                    key={index}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    title={item.name}
                                    subTitle={`Ordered: ${item.quantity}`}
                                    qtyReceived={item.quantityReceived}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </form>
    </FormikProvider>)
})

export default PurchaseOrderDetailReceivingForm